import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="results-title" data-id="element-160" data-mp="28f80yjn3pvsp">
      <div className="mx-auto max-w-5xl px-4" data-id="element-161" data-mp="28ddhl9rhabqq">
        <p className="text-center text-xs font-extrabold uppercase tracking-[.18em] text-teal" data-id="element-162" data-mp="2d6zvt6dainon">Más resultados reales</p>
        <h2 id="results-title" className="mt-3 text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-163" data-mp="2h709goskeuun">
          Bibliotecarios y docentes que ya cambiaron su forma de enseñar
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-164" data-mp="2r70wakpn7t3l">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-line bg-mist p-6" data-id="element-165" data-mp="2w2g8l8805gxw" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-teal" data-id="element-166" data-mp="3il4sbw8pv65v" />
              <blockquote className="mt-4 flex-1 text-sm italic leading-relaxed text-muted" data-id="element-167" data-mp="3dn3d5meevqzo">“{quote}”</blockquote>
              <div className="mt-5 flex items-center gap-3 border-t border-line pt-4" data-id="element-168" data-mp="38pl1vpcx8zoi">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-deep text-sm font-extrabold text-white" data-id="element-169" data-mp="a76117wow8yp">
                  {initials}
                </span>
                <span data-id="element-170" data-mp="86ze9acddl7">
                  <b className="block text-sm text-ink" data-id="element-171" data-mp="7f5d2we7nx1">{name}</b>
                  <small className="text-xs text-muted" data-id="element-172" data-mp="3scspmdryfhf9">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}